import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  margin-bottom: 10px;
  @media (max-width: 1026px) {
    padding: 20px 0;
  }
`;
export default function FilterButtonGroup(props) {
  return <Container style={props.innerStyle}>{props.children}</Container>;
}

FilterButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  innerStyle: PropTypes.object,
};

FilterButtonGroup.defaultProps = {
  innerStyle: undefined,
};
